import * as React from 'react';

function RugbyLeague(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.617 4.583c-.067-.083-.15-.15-.234-.233-1-.883-2.45-1.35-4.1-1.35-.133 0-.3 0-.45.017-2.65.133-5.283 1.416-7.25 3.516C5.3 8.967 4 11.933 4 14.667c0 1.6.467 2.983 1.317 3.866.95 1.017 2.35 1.534 4.016 1.534 1 0 2.067-.184 3.134-.584 1.716-.583 3.35-1.633 4.766-3.016C19.6 14.15 21 11.15 21 8.417a7.55 7.55 0 00-.15-1.517c-.217-.917-.633-1.7-1.233-2.317zM16.7 15.9c-1.917 1.867-4.283 3.1-6.517 3.35-1.25-.083-1.516-.367-1.566-.433.033-.134.266-.5 1.55-1.55l.3-.267c1.016-.817 3.4-2.75 5.116-4.3l.384-.35c1.05-.917 2.75-2.433 4.233-4.433.017.166.033.333.033.5 0 2.533-1.333 5.333-3.533 7.483zm-9.417-.133c-.266.1-.55.2-.75.2-.383 0-.783-.3-.85-2.634-.083-3.216 2.284-6.266 4.35-7.866 1.617-1.084 3.5-1.684 5.25-1.684 1.584 0 2.934.484 3.767 1.35l.067.034C19 8.2 15.967 10.5 14.15 11.9l-.033.017c-2.767 2.1-5.734 3.466-6.5 3.716-.117.05-.217.084-.334.134z"
        fill="currentColor"
      />
    </svg>
  );
}

export default RugbyLeague;
